import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { TICKET_STATUS_CLOSE } from '../../../assets/appConstants/constants';
import CloseChip from '../../common/ActionChip/CloseChip';
import EditChip, { EditAlarm } from '../../common/ActionChip/EditChip';
import { useNavigate } from 'react-router-dom';
import { useProject } from '../../../context/ProjectContext';
import { itemSelection } from '../../../models/itemSelection.model';


interface PrimaryMenuBarProps {
  ticket_number: string,
  ticket_status_n: any,
  action: string,
  setCurrentAction: (p: string) => void,
  canEdit?: boolean
}

const PrimaryMenuBar: React.FC<PrimaryMenuBarProps> = ({
  ticket_number,
  ticket_status_n,
  action,
  setCurrentAction,
  canEdit = false,
}) => {

  const { selectedProject } = useProject()
  const navigate = useNavigate()

  return (
    <React.Fragment>
      <CssBaseline />
      <div className='primary-menu-bar'>
        {action === 'view' && ticket_status_n && (
          <EditAlarm
            label='Editar Alarmas'
            onClick={() => setCurrentAction('edit_alarms')}
          />
        )}
        {canEdit && action === 'view' && ticket_status_n && (
          <EditChip
            label='Editar Ticket'
            onClick={() => setCurrentAction('edit')}
          />
        )}
        {action.startsWith('edit') && (
          <CloseChip
            label='Cancelar Edición'
            onClick={() => navigate(0)}
            variant='outline'
          />
        )}
        {action === 'view' && ticket_status_n && ticket_status_n.id !== TICKET_STATUS_CLOSE.id && (
          <CloseChip
            label='Cerrar Ticket'
            onClick={() => navigate(`/${selectedProject}/ticket/close/${ticket_number}`)}
            variant='filled'
          />
        )}
      </div>
    </React.Fragment>
  );
}

export default PrimaryMenuBar;